<div
  *ngIf="!isLoading; else loadingCard"
  [ngClass]="{
    'comming-soon': layout === 'default',
    'comming-soon--fullgrid': layout === 'fullgrid',
    'comming-soon--small': layout === 'small',
  }"
>
  <hdi-icon
    class="icon"
    [size]="size"
    [iconName]="icon"
    [color]="color"
  ></hdi-icon>
  <div class="content">
    <div class="content__headline" [innerHTML]="headline"></div>
    <div class="content__text" [innerHTML]="content"></div>
    <div class="content__buttons">
      <ng-container *ngIf="hasButton && buttonLayout === ButtonType.TERTIARY">
        <hdi-button
          *ngIf="hasButton && buttonLayout === ButtonType.TERTIARY"
          [label]="buttonLabel | capitalize"
          [type]="buttonLayout"
          [title]="title ?? ''"
          [hrefType]="hrefType ?? HrefType.ANGULAR_ROUTE"
          [href]="hrefType !== HrefType.OPEN_MODAL_VIDEO ? href : undefined"
          (click)="handleButtonClick()"
          (keydown)="handleKeydown($event)"
        ></hdi-button
      ></ng-container>
      <ng-container
        *ngIf="(hasButton && buttonLayout !== ButtonType.TERTIARY) || showModal"
      >
        <hdi-link
          *ngIf="
            (hasButton && buttonLayout !== ButtonType.TERTIARY) || showModal
          "
          [ngClass]="{ 'content__buttons__link--hide': showModal }"
          [label]="showModal ? '' : (buttonLabel | capitalize)"
          [type]="linkLayout"
          [href]="href ?? ''"
          [hrefType]="hrefType ?? HrefType.ANGULAR_ROUTE"
          [video]="video"
          [showModal]="showModal"
          [title]="title ?? ''"
          (closeModalTrigger)="closeModal($event)"
        ></hdi-link
      ></ng-container>
    </div>
  </div>
</div>

<!-- Loading Placeholder -->
<ng-template #loadingCard>
  <hdi-help-disruptor-loader></hdi-help-disruptor-loader>
</ng-template>
